import * as React from "react";
import { TableRowT } from "../../utils/pg-ts/pg-ts";
import { categoriesTable } from "../../domain/category";
import { pipe } from "fp-ts/function";
import { option } from "fp-ts";
import Tooltip from "@mui/material/Tooltip";

interface Props
    extends Pick<TableRowT<typeof categoriesTable>, "title" | "description"> {}

export const CategoryLabel = (p: Props) => {
    return pipe(
        p.description,
        option.fromNullable,
        option.fold(
            () => <strong>{p.title}</strong>,
            (desc) => (
                <Tooltip title={desc}>
                    <strong>{p.title}</strong>
                </Tooltip>
            )
        )
    );
};
